<template>
  <div class="page-register"
       v-ym-report:REGISTER_PAGE_EXPOSURE=""
  >
    <logo-slogan class="logo-slogan"/>
    <form class="form"
          @submit.prevent="handleSubmit">
      <div class="form-fields">
        <ym-field class="ym-field"
                  v-model.trim="mobile"
                  model="whole-line"
                  type="tel"
                  placeholder="输入手机号"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleSubmit"
        />
        <ym-field class="ym-field"
                  v-model.trim="smsCode"
                  model="whole-line"
                  placeholder="输入验证码"
                  maxlength="6"
                  :attr="{ autocomplete: false }"
                  v-ym-report:REGISTER_CODE_BUTTON_CLICK=""
                  @keyup.enter.prevent="handleSubmit"
        >
          <template #button>
            <ym-button class="sms-btn"
                       id="geetest-verify-sms-btn"
                       plain
                       type="primary"
                       size="small"
                       :disabled="disabledSmsCode"
            >{{ smsCodeText }}
            </ym-button>
          </template>
        </ym-field>
        <ym-field class="ym-field"
                  v-model.trim="password"
                  model="whole-line"
                  type="password"
                  placeholder="输入密码"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleSubmit"
                  @focusout.native="validatePassword"
        />
        <ym-field class="ym-field"
                  v-model.trim="passwordCheck"
                  model="whole-line"
                  type="password"
                  placeholder="再次输入"
                  :attr="{ autocomplete: false }"
                  @keyup.enter.prevent="handleSubmit"
                  @focusout.native="validatePasswordCheck"
        />
      </div>
      <div class="form-bottom">
        <ym-button class="submit-btn"
                   size="large"
                   type="primary"
                   :disabled="disabled"
                   v-ym-report:REGISTER_LOGON_BUTTON_CLICK=""
                   @click.prevent="handleSubmit"
        >
          注册
        </ym-button>
        <div class="user-term">
          点击注册表示您已阅读并同意
          <span class="link">
            《<router-link :to="{ name: 'UserTerm' }">服务协议</router-link>》
          </span>
        </div>
      </div>
    </form>
    <div class="btn-container"
         :class="[isWeiXin ? 'space-between' : '']"
    >
      <ym-button class="login-btn"
                 plain
                 @click="handleClickLogin"
      >
        登录
      </ym-button>
      <wechat-login v-if="isWeiXin"
                    type="register"
      />
    </div>
  </div>
</template>

<script>
  import { Field, Button } from '@ymba/ym-ui';
  import { mapActions } from 'vuex';
  import geetestMixin from '@/mixins/geetest';
  import validator from '@/utils/validator';
  import {
    getAuth, getFromLocalStorage,
    getQuery,
    getStorageRedirect, getUID,
    isWeiXinBrowser,
  } from '@/utils';
  import WechatLogin from '@/pages/Login/components/WechatLogin';
  import LogoSlogan from '@/pages/Login/components/LogoSlogan';
  import { PLAN_SURVEY_FINISH_STATUS } from '@/utils/constant';
  import { getLearningChooseTagStatus } from '@/services/learning';

  export default {
    name: 'PageRegister',
    mixins: [geetestMixin],
    metaInfo: {
      title: '注册',
    },
    components: {
      'ym-field': Field,
      'ym-button': Button,
      WechatLogin,
      LogoSlogan,
    },
    data() {
      return {
        smsCode: '',
        password: '',
        passwordCheck: '',
        submitDisabled: false,
        smsType: 'sms_registration',
      };
    },
    computed: {
      query() {
        return getQuery(this.$route.query);
      },
      disabledSmsCode() {
        return this.mobile === '' || this.smsCodeDisabled;
      },
      disabled() {
        return this.mobile === ''
          || this.smsCode === ''
          || this.password === ''
          || this.passwordCheck === ''
          || this.submitDisabled;
      },
      isWeiXin() {
        return isWeiXinBrowser();
      },
    },
    methods: {
      ...mapActions([
        'Register',
      ]),
      checkPassword() {
        if (this.passwordCheck !== '') {
          return this.password === this.passwordCheck;
        }
        return true;
      },
      validatePassword() {
        if (!this.checkPassword()) {
          this.$toast('两次输入的密码不一致');
        }
      },
      checkPasswordCheck() {
        return this.password === this.passwordCheck;
      },
      validatePasswordCheck() {
        if (!this.checkPasswordCheck()) {
          this.$toast('两次输入的密码不一致');
        }
      },
      async handleSubmit() {
        if (!validator.isMobile(this.mobile)) {
          this.$toast('请填写正确的手机号');
          return;
        }
        if (validator.isEmpty(this.smsCode)) {
          this.$toast('请填写验证码');
          return;
        }
        if (validator.isEmpty(this.password)) {
          this.$toast('请填写密码');
          return;
        }
        if (validator.isEmpty(this.passwordCheck)) {
          this.$toast('请再次输入密码');
          return;
        }
        if (!this.checkPasswordCheck()) {
          this.$toast('两次输入的密码不一致');
          return;
        }
        this.submitDisabled = true;
        try {
          await this.Register({
            mobile: this.mobile,
            smsCode: this.smsCode,
            password: this.password,
            passwordCheck: this.passwordCheck,
          });
          this.handleRedirectToLastPage();
          this.submitDisabled = false;
        } catch (e) {
          this.submitDisabled = false;
        }
      },
      async handleRedirectToLastPage() {
        const userId = getUID();
        const skipStatus = getFromLocalStorage(`${PLAN_SURVEY_FINISH_STATUS}-${userId}`);
        const chooseData = await getLearningChooseTagStatus(true);
        if (chooseData.status === 'todo' && skipStatus !== 'finished') {
          this.$router.push({ name: 'LearningSurvey', query: this.$route.query });
          return;
        }

        const { redirectTo } = this.query;
        const path = getStorageRedirect(redirectTo);
        this.$router.replace({
          path,
        });
      },
      handleClickLogin() {
        this.$router.push({ name: 'Login' });
      },
    },
    beforeRouteEnter(to, from, next) {
      const auth = getAuth();
      if (!auth) {
        next();
        return;
      }
      let { path } = from;
      if (!path) path = '/';
      next({
        path,
      });
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-register {
    min-height: 100%;
    padding-top: 90px;
    padding-bottom: 90px;
    background: @color-white;
    text-align: center;
    box-sizing: border-box;
  }

  .logo-slogan {
    margin-bottom: @size-extra-small * 1.5;
  }

  .form {
    padding: 0 @form-page-padding @size-large;
  }

  .ym-field {
    font-size: @font-size-medium;
    /deep/ .mint-field-other {
      display: flex;
      align-items: center;
    }
  }

  .sms-btn {
    border-radius: @border-radius-normal;
    font-size: @font-size-base;
    padding: 0 @size-small;
  }

  .submit-btn {
    margin: @size-medium auto @size-base;
  }

  .user-term {
    font-size: @font-size-small;
    color: @color-text-lighter;
  }

  .link {
    color: @color-link;
  }

  .btn-container {
    padding: 0 @form-page-padding;
    display: flex;
    align-items: center;
    justify-content: center;
    &.space-between {
      justify-content: space-between;
    }
  }

  .login-btn {
    height: 80px;
    width: @login-button-width;
    border-color: @color-primary;
    color: @color-text-primary;
    border-radius: @border-radius-extra-large;
  }
</style>
